import axios from "axios";

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth API
export const authApi = {
  login: (email, password) => api.post("/auth/login", { email, password }),
  register: (email, password, name) => api.post("/auth/register", { email, password, name }),
  getMe: () => api.get("/auth/me"),
};

// Departments API
export const departmentsApi = {
  getAll: () => api.get("/departments"),
  getOne: (code) => api.get(`/departments/${code}`),
};

// Categories API
export const categoriesApi = {
  getAll: () => api.get("/categories"),
  getOne: (id) => api.get(`/categories/${id}`),
  create: (data) => api.post("/categories", data),
};

// Businesses API
export const businessesApi = {
  getAll: (page = 1, limit = 20, search = "") => api.get(`/businesses?page=${page}&limit=${limit}${search ? `&search=${encodeURIComponent(search)}` : ""}`),
  getFeatured: (limit = 6) => api.get(`/businesses/featured?limit=${limit}`),
  getOne: (id) => api.get(`/businesses/${id}`),
  search: (params) => api.get("/businesses/search", { params }),
  getByDepartment: (code, limit = 20) => api.get(`/businesses/by-department/${code}?limit=${limit}`),
  getByCategory: (id, limit = 20) => api.get(`/businesses/by-category/${id}?limit=${limit}`),
  create: (data) => api.post("/businesses", data),
  update: (id, data) => api.put(`/businesses/${id}`, data),
  delete: (id) => api.delete(`/businesses/${id}`),
  toggleFeatured: (id) => api.put(`/businesses/${id}/toggle-featured`),
};

// Stats API
export const statsApi = {
  get: () => api.get("/stats"),
};

// Contact API
export const contactApi = {
  send: (businessId, data) => api.post(`/businesses/${businessId}/contact`, data),
  getAll: (params) => api.get("/contact-messages", { params }),
  markRead: (id) => api.put(`/contact-messages/${id}/read`),
  delete: (id) => api.delete(`/contact-messages/${id}`),
};

// Seed API
export const seedApi = {
  seed: () => api.post("/seed"),
};

// Upload API
export const uploadApi = {
  uploadFile: (file) => {
    const formData = new FormData();
    formData.append("file", file);
    return api.post("/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
};

// News API
export const newsApi = {
  getNews: (limit = 6) => api.get(`/news?limit=${limit}`),
};

export default api;
